import type { Slide } from '../identity/components/HeroCarousel';
import heroHandshake from '../../assets/auth-hero-partner-handshake.webp';
import heroTeam from '../../assets/auth-hero-partner-team.webp';
import heroDashboard from '../../assets/auth-hero-partner-dashboard.webp';
import heroResetRequest from '../../assets/auth-hero-partner-reset-request.webp';
import heroResetNewPassword from '../../assets/auth-hero-partner-reset-new-password.webp';

// Copy and photography taken from the approved "Partners Sign In Flow" Figma handoff's three marketing
// frames ("Partners - Sign In", "...- Sign In 4", "...- Sign In 5"). The photos are cropped from the
// handoff's own exported screenshots (no separate source image files were provided) — see
// docs/epn-36-partner-signin-gaps.md for provenance.
export const PARTNER_LOGIN_SLIDES: Slide[] = [
  {
    headline: 'Simplify Payroll for Your Clients',
    body: 'Manage payroll efficiently with powerful tools designed to save time, reduce errors, and support your clients’ growing needs.',
    image: heroHandshake,
    focalPosition: '35% 25%',
  },
  {
    headline: 'Showcase Your Brand with Pride',
    body: 'Personalize your partner portal with your business logo and details, creating a professional experience that reflects your unique brand identity.',
    image: heroTeam,
    focalPosition: '50% 20%',
  },
  {
    headline: 'Your Dashboard, All in One Place',
    body: 'Access client accounts, track payroll activities, and stay organized with a centralized and easy-to-use partner portal.',
    image: heroDashboard,
    focalPosition: '55% 15%',
  },
];

// The Partner reset-password screens show a single static photo with no headline/body/dots at all (see
// HeroCarousel's own doc comment on why a slide with no `headline` renders bare).
export const PARTNER_RESET_REQUEST_SLIDES: Slide[] = [{ image: heroResetRequest, focalPosition: '70% 20%' }];
export const PARTNER_RESET_NEW_PASSWORD_SLIDES: Slide[] = [{ image: heroResetNewPassword, focalPosition: '70% 15%' }];
